module.exports = __webpack_public_path__ + "static/media/logo-transparent.792950f7.png";